"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _emotion = require("emotion");

var root =
/*#__PURE__*/
(0, _emotion.css)("display:flex;flex-flow:row nowrap;align-items:center;padding:9px 0;");
var checkbox =
/*#__PURE__*/
(0, _emotion.css)("margin-right:16px;");

var title = function title(theme, disabled) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("flex:1;font-size:18px;color:", theme.color.black1, ";", disabled && "\n    color: ".concat(theme.color.grey1, ";\n  "))
  );
};

var count = function count(theme, disabled) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("flex:none;font-size:16px;color:", theme.color.black3, ";", disabled && "\n    color: ".concat(theme.color.grey1, ";\n  "))
  );
};

var _default = {
  root: root,
  checkbox: checkbox,
  title: title,
  count: count
};
exports.default = _default;